var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("custom-filters", {
        staticClass: "d-flex justify-space-around",
        staticStyle: { height: "96px", "overflow-y": "auto" },
        attrs: { namespace: "sensors/errors", "i18n-path": "sensors" }
      }),
      _vm._v(" "),
      _vm.frontSort
        ? _c(
            "v-data-table",
            _vm._b(
              {
                staticClass: "elevation-1 secondarybackground striped-table",
                attrs: {
                  dense: "",
                  "hide-default-footer": "",
                  "fixed-header": "",
                  "calculate-widths": "",
                  "items-per-page": _vm.data.length,
                  headers: _vm.headers,
                  items: _vm.data,
                  loading: _vm.loading,
                  height: _vm.height - 96 + "px"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "top",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-space-between" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "primary--text font-weight-bold ml-10 my-1"
                                },
                                [_vm._v("\n          Alertes Sondes\n        ")]
                              ),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                staticClass: "my-1 mr-10",
                                attrs: { dense: "", label: "Tri sur la page" },
                                model: {
                                  value: _vm.frontSort,
                                  callback: function($$v) {
                                    _vm.frontSort = $$v
                                  },
                                  expression: "frontSort"
                                }
                              }),
                              _vm._v(" "),
                              _c("custom-page-selector", {
                                staticClass: "pa-2",
                                attrs: { namespace: "sensors/errors" }
                              })
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "item.label",
                      fn: function({ item }) {
                        return [
                          item.label
                            ? _c("truncate-text-with-hover", {
                                attrs: { text: item.label, length: 25 }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  item.error_datetime.toLocaleDateString()
                                ) +
                                "\n      "
                            )
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3222056453
                )
              },
              "v-data-table",
              _vm.$attrs,
              false
            )
          )
        : _c(
            "v-data-table",
            _vm._b(
              {
                staticClass: "elevation-1 secondarybackground striped-table",
                attrs: {
                  dense: "",
                  "hide-default-footer": "",
                  "fixed-header": "",
                  "calculate-widths": "",
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDESC,
                  headers: _vm.headers,
                  "server-items-length": _vm.data.length,
                  items: _vm.data,
                  loading: _vm.loading,
                  height: _vm.height - 96 + "px"
                },
                on: {
                  "update:sortBy": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function($event) {
                    _vm.sortDESC = $event
                  },
                  "update:sort-desc": function($event) {
                    _vm.sortDESC = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "top",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-space-between" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "primary--text font-weight-bold ml-10 my-1"
                              },
                              [_vm._v("\n          Alertes Sondes\n        ")]
                            ),
                            _vm._v(" "),
                            _c("v-checkbox", {
                              staticClass: "my-1 mr-10",
                              attrs: { dense: "", label: "Tri sur la page" },
                              model: {
                                value: _vm.frontSort,
                                callback: function($$v) {
                                  _vm.frontSort = $$v
                                },
                                expression: "frontSort"
                              }
                            }),
                            _vm._v(" "),
                            _c("custom-page-selector", {
                              staticClass: "pa-2",
                              attrs: { namespace: "sensors/errors" }
                            })
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "item.label",
                    fn: function({ item }) {
                      return [
                        item.label
                          ? _c("truncate-text-with-hover", {
                              attrs: { text: item.label, length: 25 }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n        " +
                              _vm._s(item.error_datetime.toLocaleDateString()) +
                              "\n      "
                          )
                        ])
                      ]
                    }
                  }
                ])
              },
              "v-data-table",
              _vm.$attrs,
              false
            )
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }